import Vue from 'vue';
import Router from 'vue-router';
import index from '../views/index.vue';
import { perfix } from '../../utils/common.js'
Vue.use(Router);
const PCRoutes = [
  {
    path: '/',
    redirect: '/adminLogin',
  },

  {
    path: '/adminLogin',
    name: 'adminLogin',
    component: () => import('../views/login.vue'),
  },

  {
    path: '/backIndex/homeIndex',
    name: 'homeIndex',
    component: () => import('../views/index.vue'),  
    children: [
      {
        //首页
        path: '/backIndex/homeIndex',
        name: 'homeIndex',
        component: () => import('../views/home/index.vue'),  //右侧内容区
      },
      {
        //个人信息        -------------------------------------
        path: '/backIndex/personInfo',
        name: 'personInfo',
        component: () => import('../views/person/index.vue'),
      },
      {
        //个人信息        -------------------------------------
        path: '/backIndex/group',
        name: 'group',
        component: () => import('../views/person/group.vue'),
      },



      {
        //为我推荐
        path: '/backIndex/recommendInfo',
        name: 'recommendInfo',
        component: () => import('../views/recommend/index.vue'),
      },
      {
        // 我的收藏   
        path: '/backIndex/collectionInfo',
        name: 'collectionInfo',
        component: () => import('../views/collection/index.vue'),
      },
      {
        // 我的消息
        path: '/backIndex/myMessage',
        name: 'myMessage',
        component: () => import('../views/message/index.vue'),
      },
      {
        // 消息
        path: '/backIndex/messageDetail',
        name: 'messageDetail',
        component: () => import('../views/message/detail.vue'),
      },
    ],
  },

];
 const MobileRoutes = [
  {
    path: '/',
    redirect: '/adminLogin',
  },
  {
    path: '/adminLogin',
    name: 'adminLogin',
    component: () => import('../mobile/login.vue'),
  },

  {
    path: '/backIndex',
    name: 'backIndex',
    component: () => import('../mobile/index.vue'),  
    children: [
      {
        path: '/backIndex/homeIndex',
        name: 'homeIndex',
        component: () => import('../mobile/home/index.vue'),  
      },
      {
        //个人信息    -------------------------------------
        path: '/backIndex/personInfo',
        name: 'personInfo',
        component: () => import('../mobile/person/index.vue'),
      },
      {
        //为我推荐
        path: '/backIndex/recommendInfo',
        name: 'recommendInfo',
        component: () => import('../mobile/recommend/index.vue'),
      },
      {
        // 我的收藏   
        path: '/backIndex/collectionInfo',
        name: 'collectionInfo',
        component: () => import('../mobile/collection/index.vue'),
      },
      {
        // 我的消息
        path: '/backIndex/myMessage',
        name: 'myMessage',
        component: () => import('../mobile/message/index.vue'),
      },
      {
        // 消息
        path: '/backIndex/messageDetail',
        name: 'messageDetail',
        component: () => import('../mobile/message/detail.vue'),
      },
    ],
  },

]; 
let routes = [];
if (perfix()) {routes = [...MobileRoutes];}else{routes = [...PCRoutes];}
export default new Router({routes,}); 
const VueRouterPush = Router.prototype.push;
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err);
};

